"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gamesInOneSlide = void 0;
exports.gamesInOneSlide = {
    2: {
        mobile: 4,
        tablet: 10,
        desktop: 9,
    },
    mobile: 4,
    tablet: 8,
    desktop: 12,
};
